import request from '@/utils/request'

export const getNewsimgList = ({ page, size, type }) => {
  return request({
    url: `/news/newsimg/${page}/${size}`,
    params: {
      type
    }
  })
}

export const postNewsimgEdit = (data) => {
  return request({
    method: 'post',
    url: '/news/newsimg',
    data
  })
}

export const putNewsimgAdd = (data) => {
  return request({
    method: 'put',
    url: '/news/newsimg/',
    data
  })
}

export const getNewsimgDetail = (id) => {
  return request({
    url: `/news/newsimg/${id}`
  })
}

export const deleteNewsimgDel = (id) => {
  return request({
    method: 'delete',
    url: `/news/newsimg/${id}`
  })
}

export const delNewsimgList = (data) => {
  return request({
    method: 'delete',
    url: '/news/newsimg/all',
    data
  })
}

export const getPollImg = () => {
  return request({
    url: '/news/index/poll/img'
  })
}

export const getLineImg = () => {
  return request({
    url: '/news/index/line/img'
  })
}
